import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Message from '../../components/Message';

const Wrapper = styled.div`
  margin-bottom: var(--space-200);
`;

const CancelledEventMessage = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Message variant="informative">{t('event.cancelledEvent')}</Message>
    </Wrapper>
  );
};

export default CancelledEventMessage;
